import { Expose } from "class-transformer";
import { BaseModel } from "./base.model";

export class PolicyPayment extends BaseModel {
    @Expose() hasDebitMembership = false; // false para SOAT

    @Expose() paymentPlan?: string;

    @Expose() totalPremium = 0.0;

    @Expose() paymentWay? = "";

    @Expose() description? = "";
}
